import { searchQueryIsNotEmpty } from "../../../utils/searchQuery";
import {PathPickerType} from "../../../types/enums";
import * as Path from "path";

const {
  Button,
  TextField,
} = window.Edocat.Components;

interface SearchProps {
  doSearch: Function;
  fetchContent: Function;
  setProperty: Function;
  searchQuery: string;
  loadingContent: boolean;
  type: PathPickerType;
}

export default class Search extends window.React.PureComponent<SearchProps> {
  onSearchFieldChange = async (event: React.ChangeEvent) => {
    const newSearchQuery: string = (event.target as HTMLInputElement).value;

    const { fetchContent, setProperty } = this.props;

    setProperty("searchQuery", newSearchQuery);

    //If the user cleared the input, fetch content of the last open folder, if any.
    if (newSearchQuery.length === 0) {
      fetchContent();
    }
  };

  onSearch = () => {
    const { doSearch, searchQuery } = this.props;

    doSearch(searchQuery);
  };

  onKeyUp = (event: React.MouseEvent) => {
    event.persist();
    if (event.keyCode === 13) {
      this.onSearch();
    }
  };

  render() {
    const { searchQuery, loadingContent, type } = this.props;
    const isSearchQueryValid = searchQueryIsNotEmpty(searchQuery);

    return (
      <div className="structure-item search">
        <TextField
          label={window.Alfresco.messages.global[`edocat.global.path-picker.search-${type === PathPickerType.FOLDER ? 'folder' : 'all'}`]}
          placeholder={window.Alfresco.messages.global['edocat.global.path-picker.search-placeholder']}
          value={searchQuery}
          onChange={this.onSearchFieldChange}
          onKeyUp={isSearchQueryValid ? this.onKeyUp : null}
          autoFocus
          type="search"
          disabled={loadingContent}
        />
        <Button
          primary
          label={window.Alfresco.messages.global['button.search']}
          onClick={this.onSearch}
          disabled={!isSearchQueryValid || loadingContent}
        />
      </div>
    );
  }
}
